// src/config/company.js — 공개 사이트 푸터/문의에 쓰는 회사 정보
// 비어 있는 항목은 화면에 표시하지 않는다. (전자상거래법 표시사항 — 실제 값 확인 후 채울 것)
export const COMPANY = {
  brand: 'GATEON',
  legalName: '',            // 상호
  ceo: '',                  // 대표자
  businessNumber: '',       // 사업자등록번호
  mailOrderNumber: '',      // 통신판매업 신고번호
  address: '',              // 사업장 주소
  phone: '02-325-4820',
  email: 'sales@imotto.kr',
};

export const companyInfoRows = () =>
  [
    ['상호', COMPANY.legalName],
    ['대표', COMPANY.ceo],
    ['사업자등록번호', COMPANY.businessNumber],
    ['통신판매업 신고', COMPANY.mailOrderNumber],
    ['주소', COMPANY.address],
  ].filter(([, v]) => v);
